<div class="d-flex" id="sidebar">
    <!-- || 'https://api.a2ginfra.syven.in',//  -->
    <div [ngClass]="{'logo-area':true}"><img [src]="logoUrl" alt="Organization Logo" /></div>
    <div class="container-fluid">
        <div class="row d-flex  me-0">
            <div class="col-md-6 d-flex toggle">
                <i [ngClass]="{'breadcum':true}" (click)="toggleSidebar()"><span class="profileImg"><img
                            src="../../assets/images/Toggle icon.svg"
                            style="width: 30px;cursor: pointer; cursor: pointer;" alt=""></span></i>
                <div class="col-md-6 branding-area" style="justify-content: flex-start;">
                    <strong>{{selectedSiteName}}</strong>
                </div>
            </div>
            <div class="col-md-6 branding-area">
                <strong>{{organisationName}}</strong>
                <i><img src="../../assets/images/bell.svg" class="bellicon" alt=""></i>
                <div class="dropdownMenu">
                    <div class="profile-container">
                        <img src="../../assets/images/profileDefaultPic.svg" class="profile-avatar" alt="">
                        <div class="dropdownMenu-content">
                            <span class="dropdownMenu-content-option" (click)="showUserProfileModal()">Profile</span>
                            <span class="dropdownMenu-content-option" (click)="showSwitchSite()">Switch
                                Subscriber</span>
                            <span class="dropdownMenu-content-option" (click)="logout()">Logout</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sub-header *ngIf="!hideSubHeader"></app-sub-header>
<app-site-switch *ngIf="commonService.showSiteModal | async"></app-site-switch>
<app-user-account-profile *ngIf="commonService.showUserProfileModal | async"></app-user-account-profile>